__turbopack_context__.v({
  "actions": "contact-footer-module__OlQj8q__actions",
  "brandName": "contact-footer-module__OlQj8q__brandName",
  "cableDesktop": "contact-footer-module__OlQj8q__cableDesktop",
  "cableMobile": "contact-footer-module__OlQj8q__cableMobile",
  "content": "contact-footer-module__OlQj8q__content",
  "details": "contact-footer-module__OlQj8q__details",
  "divider": "contact-footer-module__OlQj8q__divider",
  "field": "contact-footer-module__OlQj8q__field",
  "footer": "contact-footer-module__OlQj8q__footer",
  "form": "contact-footer-module__OlQj8q__form",
  "formIntro": "contact-footer-module__OlQj8q__formIntro",
  "mailIcon": "contact-footer-module__OlQj8q__mailIcon",
  "plane": "contact-footer-module__OlQj8q__plane",
  "planeFly": "contact-footer-module__OlQj8q__planeFly",
  "planeReturn": "contact-footer-module__OlQj8q__planeReturn",
  "sendGlass": "contact-footer-module__OlQj8q__sendGlass",
  "sentTint": "contact-footer-module__OlQj8q__sentTint",
});
